import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login/index'

const operationManualInbound = () => import( '@/pages/sort/manualInbound.vue')
const operationLockerReturnInbound = () => import( '@/pages/sort/lockerReturnInbound.vue')
const operationCloseBox = () => import( '@/pages/sort/closeBox.vue')
const operationOutbound = () => import( '@/pages/sort/outbound.vue')
const operationReturn = () => import( '@/pages/sort/return.vue')
const operationCheck = () => import('@/pages/sort/check.vue')
const dashboardInOut = () => import( '@/pages/dashboard/todayInAndOut.vue')
const manualSorting = () => import( '@/pages/dashboard/manualSorting.vue')

const problemWarehouse = () => import( '@/pages/sort/problemWarehouse.vue')


const dashboardVolumeBySortCode = () => import('@/pages/dashboard/volumeBySortCode.vue')
const waveList = () => import('@/pages/consolidation/waveList.vue')
const autoSorterDashboard = () => import('@/pages/autoSorter/autoSorterDashboard.vue')
const autoSorterControlPanel = () => import('@/pages/autoSorter/autoSorterControlPanel.vue')
const autoSorterProfiles = () => import('@/pages/autoSorter/autoSorterProfiles.vue')
//DHL
const inboundPackageHandling = () => import('@/pages/DHLProject/inboundPackageHandling.vue')
const collection = () => import('@/pages/DHLProject/collection.vue')
const orderInfo = () => import('@/pages/DHLProject/orderInfo.vue')

const pySortInbound = () => import( '@/pages/sort/pySortInbound.vue')
const pyReturnInbound = () => import( '@/pages/sort/pyReturnInbound.vue')
const handoverReport = () => import( '@/pages/sort/handoverReport.vue')
const destPickupInbound = () => import( '@/pages/sort/destPickupInbound.vue')


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  defaultRoute: 'manualInbound',
  routes: [
    {
      path: '/',
      redirect: '/login'
    }, {
      path: '/login', name: 'login',
      component: login => require(['@/pages/login/index'], login)
    }, {
      path: '/home',
      component: home => require(['@/pages/home/index'], home),
      children: [
        {
          path: '/operation/manualInbound',
          name: 'manualInbound',
          component: operationManualInbound
        },
        {
          path: '/operation/lockerReturnInbound',
          name: 'lockerReturnInbound',
          component: operationLockerReturnInbound
        },
        {
          path: '/operation/closeBox',
          name: 'closeBox',
          component: operationCloseBox
        },
        {
          path: '/operation/outbound',
          name: 'outbound',
          component: operationOutbound
        },
        {
          path: '/operation/return',
          name: 'return',
          component: operationReturn
        },
        {
          path: '/operation/problemWarehouse',
          name: 'problem',
          component: problemWarehouse
        },
        {
          path: '/operation/check',
          name: 'orderCheck',
          component: operationCheck
        },
        {
          path: '/dashboard/today-in-and-out',
          name: 'dashboardInOut',
          component: dashboardInOut
        },
        {
          path: '/dashboard/manual-sorting',
          name: 'manualSorting',
          component: manualSorting
        },
        {
          path: '/dashboard/volume-by-sort-code',
          name: 'volumeBySortCode',
          component: dashboardVolumeBySortCode
        },
        {
          path: '/consolidation/wave-list',
          name: 'waveList',
          component: waveList
        },
        {
          path: '/auto-sorter',
          name: 'autoSorterDashboard',
          component: autoSorterDashboard
        },
        {
          path: '/auto-sorter/control-panel',
          name: 'autoSorterControlPanel',
          component: autoSorterControlPanel
        },
        {
          path: '/auto-sorter/profiles',
          name: 'autoSorterProfiles',
          component: autoSorterProfiles
        },
        {
          path: '/DHL-project/inboundPackageHandling',
          name: 'inboundPackageHandling',
          component: inboundPackageHandling
        },
        {
          path: '/DHL-project/collection',
          name: 'collection',
          component: collection
        },
        {
          path: '/DHL-project/orderInfo',
          name: 'orderInfo',
          component: orderInfo
        },
        {
          path: '/auto-sorter/py-inbound',
          name: 'pySortInbound',
          component: pySortInbound
        },
         {
          path: '/auto-sorter/py-return-inbound',
          name: 'pyReturnInbound',
          component: pyReturnInbound
        },
        {
          path: '/auto-sorter/destPickup-inbound',
          name: 'destPickupInbound',
          component: destPickupInbound
        },
        {
          path: '/auto-sorter/report',
          name: 'handoverReport',
          component: handoverReport
        }
      ]
    },
    {
      path: '*',
      redirect: '/login'
    }]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js